/** Shared mega menu typography — 14px, bold 700 / regular 400 */
export const megaMenuBold = "text-[14px] font-bold leading-snug"
export const megaMenuRegular = "text-[14px] font-normal leading-snug"
